import { makeStyles } from "@material-ui/core";

export const useDataUsageStyles = makeStyles(() => ({
    accessibilityInfo: {
        display: "inline-block",
        width: 200
    }
}));
